export default __webpack_public_path__ + "/dist/images/italian-thumbnail.fe8282956eec1ccaa2acfa827f0e4161.png";